<template>
  <div>
    <h3>All Unsubscribed Contacts <span>({{ count | prettyNumber }})</span></h3>
    <div class="sub-text">Unreachable contacts</div>
    <DataTable :filter="'unsubscribed'" :count="count" />
  </div>
</template>
<script>
  import DataTable from './DataTable';

  export default {
    props: ['count'],
    components: {
      DataTable,
    },
    data() {
      return {};
    },
  };
</script>
